export default "__VITE_ASSET__D6f0bdB0__"